import { ReducerUtil } from 'doctivity-shared/utils';

import {
  API_TAXONOMY_TABLE,
  API_TAXONOMY_LIST,
  API_TAXONOMY_UPSERT,
} from 'store/actions/taxonomyActions';

export const taxonomy = (state = {}, action = null) => {
  const result = ReducerUtil.simpleReduce(
    state,
    action,
    API_TAXONOMY_TABLE,
    API_TAXONOMY_LIST,
    API_TAXONOMY_UPSERT,
  );
  if (result.actionConsumed) {
    return result.state;
  }
  return state;
};
